export const generateDriversOptions = (): uui.domain.ui.list.ListOptions => {
  return {
    search: {
      query: '',
      fields: ['name', 'deployment.email'],
      operator: 'or',
      exactMatch: false,
    },
    filter: [],
    sort: [
      {
        field: 'name',
        direction: 'asc',
      },
      {
        field: 'deployment.email',
        direction: 'asc',
      },
    ],
    group: [],
  }
}
